module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-order-details"
  }, [(!_vm.order) ? _c('page-loader') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.order) ? _c('div', [_c('div', {
    staticClass: "padded-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 column"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('order.label.order-no')) + " " + _vm._s(_vm.order.number))])])])]), _vm._v(" "), _c('order-detail-overview', {
    attrs: {
      "order-number": _vm.order.number,
      "order-ref": _vm.order.ref,
      "order-date": _vm.order.date,
      "order-status": _vm.order.status,
      "order-delivery-from": _vm.order.delivery.fromDate,
      "order-delivery-to": _vm.order.delivery.toDate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padded-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 column"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('order.label.ordered-items')) + " (" + _vm._s(_vm.order.orderLines.length) + ")")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "article-list"
  }, _vm._l((_vm.order.orderLines), function(article) {
    return _c("article-list-item", {
      key: _vm.order.number,
      tag: "li",
      attrs: {
        "article-ref": article.ref,
        "article-name": article.name,
        "article-status": article.status,
        "article-ordered-qty": article.orderedQty,
        "article-shipped-qty": article.shippedQty,
        "article-note": article.note,
        "delivery-tracking": article.delivery.tracking,
        "delivery-date": article.delivery.date,
        "delivery-date-is-different": article.delivery.dateIsDifferent,
        "delivery-date-has-changed": article.delivery.dateHasChanged
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "bloc-infos padded-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 medium-6 column no-top-border"
  }, [_c('order-info-block', {
    attrs: {
      "block-title": _vm.$t('order.label.delivery-address')
    }
  }, [(_vm.order.deliveryAddress.lastname) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.deliveryAddress.lastname))]) : _vm._e(), _vm._v(" "), (_vm.order.deliveryAddress.firstname) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.deliveryAddress.firstname))]) : _vm._e(), _vm._v(" "), (_vm.order.deliveryAddress.address1) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.deliveryAddress.address1))]) : _vm._e(), _vm._v(" "), (_vm.order.deliveryAddress.address2) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.deliveryAddress.address2))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [(_vm.order.deliveryAddress.zipcode) ? _c('span', [_vm._v(_vm._s(_vm.order.deliveryAddress.zipcode) + " ")]) : _vm._e(), _vm._v(" "), (_vm.order.deliveryAddress.city) ? _c('span', [_vm._v(_vm._s(_vm.order.deliveryAddress.city))]) : _vm._e()]), _vm._v(" "), (_vm.order.deliveryAddress.country) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.deliveryAddress.country))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 column no-right-border"
  }, [_c('order-info-block', {
    attrs: {
      "block-title": _vm.$t('order.label.billing-address')
    }
  }, [(_vm.order.invoiceAddress.lastname) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.invoiceAddress.lastname))]) : _vm._e(), _vm._v(" "), (_vm.order.invoiceAddress.firstname) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.invoiceAddress.firstname))]) : _vm._e(), _vm._v(" "), (_vm.order.invoiceAddress.address1) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.invoiceAddress.address1))]) : _vm._e(), _vm._v(" "), (_vm.order.invoiceAddress.address2) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.invoiceAddress.address2))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [(_vm.order.invoiceAddress.zipcode) ? _c('span', [_vm._v(_vm._s(_vm.order.invoiceAddress.zipcode) + " ")]) : _vm._e(), _vm._v(" "), (_vm.order.invoiceAddress.city) ? _c('span', [_vm._v(_vm._s(_vm.order.invoiceAddress.city))]) : _vm._e()]), _vm._v(" "), (_vm.order.invoiceAddress.country) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.order.invoiceAddress.country))]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 medium-6 column"
  }, [_c('order-info-block', {
    attrs: {
      "block-title": _vm.$t('order.label.delivery-mode')
    }
  }, [(_vm.order.delivery.mode) ? _c('p', [_vm._v(_vm._s(_vm.$t('order.label.delivery.' + _vm.order.delivery.mode)))]) : _c('p', [_vm._v(_vm._s(_vm.$t('order.label.delivery.none')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 column no-right-border"
  }, [_c('order-info-block', {
    attrs: {
      "block-title": _vm.$t('order.label.payment-mode')
    }
  }, [(_vm.order.payment.mode) ? _c('p', [_vm._v(_vm._s(_vm.$t('order.label.payment.' + _vm.order.payment.mode)))]) : _c('p', [_vm._v(_vm._s(_vm.$t('order.label.payment.none')))])])], 1)])])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f714a134!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageOrderDetails.vue
// module id = 309
// module chunks = 2